import React from 'react';

const NotFoundLayout = () => {
  return (
    <div>
      Not found
    </div>
  );
};

export default NotFoundLayout;
